import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'index',
        component: () => import('~/pages/Index.vue')
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('~/pages/Home.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('~/pages/About.vue')
    },
    {
        path: '/training',
        name: 'training',
        component: () => import('~/pages/Training.vue')
    },
    {
        path: '/gallery',
        name: 'gallery',
        component: () => import('~/pages/Gallery.vue')
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('~/pages/Contact.vue')
    },
    {
        path: '/:catchAll(.*)',
        name: 'error',
        component: () => import('~/pages/Error.vue')
    }
]

export default new VueRouter({
    mode: 'history',
    routes,
})

